import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateVideoConferenceCallRequestFailure({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isCreateVideoConferenceCallRequestPending({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isCreateVideoConferenceCallRequestSuccess({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
